import { storeToRefs } from 'pinia'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'

import { useStoreRooms } from '@/entities/room'

import { useCurrentUser } from '@/shared/composables/current-user'
import type { Contact } from '@/shared/types/api'

import { isEligibleGroupRoomForContact } from './get-eligible-group-rooms'

export const useEligibleGroupRoomsForContact = (contact: MaybeRefOrGetter<Contact | undefined>) => {
  const { roomsList } = storeToRefs(useStoreRooms())
  const { currentUser } = useCurrentUser()

  const eligibleRooms = computed(() => {
    const currentContact = toValue(contact)
    if (!currentContact) {
      return []
    }

    return roomsList.value.filter((room) => (
      isEligibleGroupRoomForContact(room, currentContact, currentUser.value?.imLogin)
    ))
  })

  return {
    eligibleRooms,
    hasEligibleChats: computed(() => eligibleRooms.value.length > 0),
  }
}
